module.exports = __webpack_public_path__ + "resources/img/img_ai_easymaker_m.3725b7959d1a808634ec2ea3c01c5328.png";